const toNumber = (value) => {
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
};

const slugify = (value) => (value || '')
  .toString()
  .trim()
  .toLowerCase()
  .replace(/[^a-z0-9]+/g, '-')
  .replace(/^-+|-+$/g, '')
  .slice(0, 60);

export const normalizePlace = (item) => {
  if (!item) return null;

  const lat = toNumber(item.latitude ?? item.lat ?? item?.coordinates?.latitude ?? item?.coordinates?.lat);
  const lng = toNumber(item.longitude ?? item.lng ?? item.lon ?? item?.coordinates?.longitude ?? item?.coordinates?.lng);
  const name = item.name || item.title;
  if (!name || lat === null || lng === null) return null;

  const id = `${item.location_id || item.id || slugify(name)}-${Math.round(lat * 1000)}-${Math.round(lng * 1000)}`;

  return {
    id,
    sourceId: item.location_id || item.id || id,
    name,
    lat,
    lng,
    rating: toNumber(item.rating) || 0,
    reviews: toNumber(item.num_reviews || item.review_count || item.reviews_count) || 0,
    priceLevel: item.price_level || 'N/A',
    address: item.address || item.address_obj?.address_string || '',
    phone: item.phone || '',
    photoUrl: item.photo?.images?.large?.url
      || item.photo?.images?.original?.url
      || item.images?.[0]?.url
      || 'https://images.unsplash.com/photo-1483729558449-99ef09a8c325?auto=format&fit=crop&w=1200&q=80',
    cuisines: (item.cuisine || item.cuisines || []).map((entry) => entry.name || entry).filter(Boolean),
    ranking: item.ranking || 'Not ranked',
    summaryText: item.summaryText || item.description || '',
    statusText: item.statusText || item.open_now_text || '',
    distanceText: item.distanceText || item.distance_string || '',
    category: item.category || item.subtype || '',
    sourceUrl: item.web_url || '',
    website: item.website || '',
    isOpenNow: typeof item.isOpenNow === 'boolean'
      ? item.isOpenNow
      : item.open_now_text?.toLowerCase()?.includes('open') || false,
  };
};
